import React, { createRef } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import toast from 'react-hot-toast';
import { Input, Spinner } from '../../../components';
import { classNames, Constants, formatMiles } from '../../../utils';
import { GeneralService, PurchasesService } from '../../../services';
import { Vector4 } from '../../../assets/img';
import { CloseIcon } from '../../../assets/icons';

const getTotals = (total) => {
	const subtotal = total;
	let igtf = 0;
	let iva = 0;
	let amount = 0;

	// iva = (total * Constants.TAXES.IVA) / 100;
	igtf = (total * Constants.TAXES.IGTF) / 100;
	amount = subtotal + igtf + iva;

	return { subtotal, igtf, iva, amount };
};

class PaymentZelle extends React.Component {

	state = {
		isLoading: false,
		showConfirmModal: false,
		request: this.props.request?.purchase,
		form: {
			paymentMethodId: Constants.PAYMENT.METHOD.ZELLE,
			name: '',
			lastname: '',
			account: '',
			date: '',
			reference: '',
			conversion: 1,
			voucher: '',
			...getTotals(this.props.request?.purchase?.total),
		},
		data: null,
	}

	confirmModalRef = createRef();
  cartButtonRef = createRef();
  goBack = createRef();

	componentDidMount() {
    this.cartButtonRef.current = document.getElementById('header-cart');
    this.cartButtonRef.current.classList.add('hidden');
    this.goBack.current = document.getElementById('header-goback');
    this.goBack.current.classList.remove('hidden');

    if (!this.props.request?.purchase) this.props.history.replace('/');

		this.getSelects();
	}

  componentWillUnmount() {
    this.cartButtonRef.current.classList.remove('hidden');
    this.goBack.current.classList.add('hidden');
  }

	getSelects = async () => {
		Promise.all([
			GeneralService.getPaymentMethodInfo(Constants.PAYMENT.METHOD.ZELLE),
		])
			.then(res => this.setState({ data: res[0][0] }))
			.catch(console.log);
	}

	change = (value,target) => {
		this.setState({
			form: { ...this.state.form, [target]: value },
		});
	}

	submit = async () => {
		if (!this.isValidForm()) return;

		const { form, request } = this.state;

		const data = {
			payment: {
				...form,
				date: moment(form.date).format('YYYY-MM-DD'),
			},
			request: {
				...request,
				conversion: form.conversion,
			},
			hasFile: false,
		};

		if (form.voucher) {
			data.hasFile = true;
			data.voucher = form.voucher;
			data.payment.voucher = undefined;
		}

		this.props.request?.products?.forEach(cartItem => {
			cartItem.beneficiaries.forEach(benef => {
				// Agrega los documentos requeridos a la raíz del objeto
				if (benef?.required_docs?.length) {
					benef?.required_docs.filter(x => !!x.file)?.forEach(x => {
						data.hasFile = true;
						const itemName = `required_docs_${x.id}_${benef.id}`;
						data[itemName] = x.file;
						data.request[itemName] = undefined;
					});
				}
			});
		});

		if (data.hasFile) {
			data.payment = JSON.stringify(data.payment);
			data.request = JSON.stringify(data.request);
		}

		try {
			await this.setState({ isLoading: true }); 
			await PurchasesService.create(data);
			this.props.dispatch({ type: 'SET_REQUEST', payload: {} });
			this.props.dispatch({ type: 'SET_CART', payload: [] });
			this.confirmModalRef.current?.showModal();

		} catch (error) {
			console.log(error);
		}

		await this.setState({ isLoading: false }); 
	}

	isValidForm = (showError = true) => {
		const onError = (msg) => {
			if (showError) toast.error(msg);
			return false;
		};

		const { form } = this.state;

		if (!form.name)
			return onError('El nombre es obligatorio');

		if (!form.lastname)
			return onError('El apellido es obligatorio');

		if (!form.date)
			return onError('La fecha es obligatoria');

		return true;
	}

	closeConfirmModal = () => {
		this.confirmModalRef.current?.close();
		this.props.history.push('/');
	}

	render() {

		const isNextStepEnabled = this.isValidForm(false);
		const { data, form, isLoading } = this.state;

		return (
			<>
				{isLoading && (
					<div className="w-screen h-screen fixed inset-0 z-[70] flex justify-center items-center bg-white/30">
						<Spinner />
					</div>
				)}

				<dialog
					ref={this.confirmModalRef}
					className="fixed inset-0 z-50 overflow-y-auto bg-transparent"
					onClose={this.closeConfirmModal}
				>
					<div
						className="w-[20rem] bg-white rounded-xl overflow-hidden p-4 flex flex-col items-center"
						onClick={this.closeConfirmModal}
					>
						<button className="absolute top-3 right-3">
							<img src={CloseIcon} className="w-4 h-4 object-contain" alt="" />
						</button>

						<img src={Vector4} className="w-32 h-32 object-contain" alt="" />
						<p className="text-center font-semibold">
							Su pago será validado por el administrador
						</p>
					</div>
				</dialog>

				<div className="w-full sm:w-[30rem] mx-auto flex flex-col gap-4 mt-8 lg:mt-0">
					<div className="w-full pt-2">
						<p className="text-center font-bold text-darkBlue text-4xl">
							{ formatMiles(form.amount,2) }
						</p>

						<div className="[&>div]:flex [&>div]:justify-between">
							<div>
								<p className="font-semibold text-gray3">Sub-Total</p>
								<p className="font-bold text-darkBlue">{ formatMiles(form.subtotal) }</p>
							</div>
							<div>
								<p className="font-semibold text-gray3">IGTF</p>
								<p className="font-bold text-darkBlue">{ formatMiles(form.igtf) }</p>
							</div>
							<div>
								<p className="font-semibold text-gray3">Total</p>
								<p className="font-bold text-darkBlue">{ formatMiles(form.amount) }</p>
							</div>
						</div>

						<div className="border-t border-[#AAAAAA] my-2" />

						<div className="[&>div]:flex [&>div]:justify-between">
							<div>
								<p className="font-semibold text-gray3 text-sm">Nombre</p>
								<p className="font-bold text-darkBlue text-sm">{ data?.name ?? '-'}</p>
							</div>
							<div>
								<p className="font-semibold text-gray3 text-sm">Correo</p>
								<p className="font-bold text-darkBlue text-sm">{ data?.account_number ?? '-' }</p>
							</div>
						</div>

						<div className="border-t border-[#AAAAAA] my-2" />

						<p className="font-semibold text-2xl text-darkBlue mt-5 mb-2">
							Verificar pago
						</p>

						<div className="flex flex-col gap-y-4">
							<Input
								placeholder="Nombre"
								value={form.name}
								onValueChange={v => this.change(v,'name')}
							/>

							<Input
								placeholder="Apellido"
								value={form.lastname}
								onValueChange={v => this.change(v,'lastname')}
							/>

							<Input
								placeholder="Correo (opcional)"
								value={form.account}
								onValueChange={v => this.change(v,'account')}
							/>

							<Input
								type="date"
								placeholder="Fecha de pago"
								value={form.date}
								onValueChange={v => this.change(v,'date')}
							/>

							<Input
								placeholder="Confirmación (opcional)"
								value={form.reference}
								onValueChange={v => this.change(v,'reference')}
							/>
						</div>
					</div>

					<div>
						<button
							className={classNames(
								'rounded-lg w-full text-center h-10 font-bold text-lg my-2 disabled:bg-gray6 disabled:text-gray3',
								isNextStepEnabled ? 'bg-blue text-white' : 'text-gray bg-gray6'
							)}
							onClick={this.submit}
							disabled={!isNextStepEnabled}
						>
							<span>Aceptar</span>
						</button>
					</div>
				</div>
			</>
		);
	}
}

export default connect(state => ({
	request: state.request,
}))(PaymentZelle);
